import { render, staticRenderFns } from "./WeekView.vue?vue&type=template&id=f0f946d6&scoped=true"
import script from "./WeekView.vue?vue&type=script&lang=js"
export * from "./WeekView.vue?vue&type=script&lang=js"
import style0 from "./WeekView.vue?vue&type=style&index=0&id=f0f946d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f946d6",
  null
  
)

export default component.exports